import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'metal-banner',
    templateUrl: './metal.component.html',
    styleUrls: ['./metal.component.css'],
    standalone: false
})
export class MetalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
